<div fxLayout="row {{ extra_layout }}" fxLayoutAlign="{{ layout_alignment }}" fxLayoutGap="{{ layout_gap }}">
  <template #rlayout></template>
</div>
